import axiosInstance from './BaseService';

// Function to upload and process the image
const uploadImagePhysicalFile = async (file: File, type: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    // Don't set Content-Type header for FormData - let browser set it with boundary
    const response = await axiosInstance.post(
      `/upload/${type}`,
      formData
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// Upload Image to Db
const uploadImageToDb = async (file: File, type: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    // Don't set Content-Type header for FormData - let browser set it with boundary
    const response = await axiosInstance.post(
      `/image/upload/${type}`,
      formData
    );

    return response.data;
  }
  catch (error) {
    throw error;
  }
}

// Function to delete an image
const deleteImage = async (uploadPath:string,imageId: string) => {
  try {
    const response = await axiosInstance.delete(`/image/file/${uploadPath}/${imageId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

// Generic file upload function
const uploadFile = async (file: File, type: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `/upload/${type}`,
      formData
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export  {
  uploadImagePhysicalFile,uploadImageToDb, deleteImage, uploadFile
};